import axios from "axios";
import React, { Component } from "react";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";
import { withRouter } from "../../components/withRouter";
import { getZplImage, localServer, zplDelete } from "../../Path/Path";
import { Autocomplete, Dialog, DialogContent, IconButton, TextField, Typography } from "@mui/material";
import AlertDialog from "../../components/AlertDialog";
import { PaginatedItemsOffline } from "../../components/PaginatedOffline";
import { IoClose } from "react-icons/io5";
class Zpl extends Component {
    state = {
        data: [],
        tableFilter: [],
        zplFilter: [], // source list for filter options
        searchVal: '',
        itemsPerPage: 10,
        refreshKey: 0,
        previewById: {},
        previewLoadingId: null,
        previewModalOpen: false,
        previewModalId: null,
        laoding: false,
        deleteModal: null,
    }
    async componentDidMount() {
        this.setState({ loading: true })
        try{
        const zpl = await axios.get(`${localServer}store/zpl/get`)
        console.log(zpl);
        this.setState({ data: zpl.data, tableFilter: zpl.data, zplFilter: zpl.data })
        this.setState({ loading: false })
         } catch (error) {
            this.setState({loading: false})
            toast.error("Something went wrong")
        }
    }
    deleteHandler = async (id) => {
        this.setState({ loading: true })
        await zplDelete(id)
            .then((async res => {
                toast.success("Zpl Deleted")
                this.setState({deleteModal : null})
                const zpl = await axios.get(`${localServer}store/zpl/get`)

                this.setState((prev) => ({ data: zpl.data, tableFilter: zpl.data, zplFilter: zpl.data, refreshKey: prev.refreshKey + 1 }))
                this.setState({ loading: false })
            }))
            .catch((err => {
                toast.error("Something Went Wrong")
            }))


    }
    editHandler = (item) => {
        // Extract only serializable fields to avoid DataCloneError with React elements
        const serializableItem = {
            _id: item._id,
            zplName: item.zplName,
            zplBody: item.zplBody
        };
        this.props.history("/addZpl", { state: { item: serializableItem } })
    }

    onSearchChange = () => {
        const search = (this.state.searchVal || "").toLowerCase().trim();

        const filtered = !search
            ? this.state.data
            : this.state.data.filter((item) =>
                (item?.zplName || "").toLowerCase().includes(search)
              );

        this.setState({ tableFilter: filtered, refreshKey: this.state.refreshKey + 1 });
        if (search && filtered?.length === 0) toast.error("Data not found");
    }

    arrayBufferToBase64 = (buffer) => {
        let binary = "";
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    };

    loadPreview = async (item) => {
        try {
            if (!item?._id || !item?.zplBody) return;
            if (this.state.previewById[item._id]) return;

            this.setState({ previewLoadingId: item._id });
            // Same approach as TagIT screen: call Labelary directly via getZplImage()
            const imageData = await getZplImage(item.zplBody);
            const base64Image = this.arrayBufferToBase64(imageData?.data);
            const dataUrl = `data:image/png;base64,${base64Image}`;

            this.setState({
                previewById: { ...this?.state?.previewById, [item._id]: dataUrl },
                previewLoadingId: null,
            });
        } catch (e) {
            // If preview fails while modal is open for this row, close it automatically.
            this.setState((prev) => ({
                previewLoadingId: null,
                ...(prev.previewModalOpen && prev.previewModalId === item?._id
                    ? { previewModalOpen: false, previewModalId: null }
                    : {}),
            }));
            toast.error("Unable to render ZPL preview");
        }
    }

    openPreviewModal = async (item) => {
        if (!item?._id) return;
        this.setState({ previewModalOpen: true, previewModalId: item._id });

        // Load preview if not already cached
        if (!this.state.previewById?.[item._id]) {
            await this.loadPreview(item);
        }
    }

    closePreviewModal = () => {
        this.setState({ previewModalOpen: false, previewModalId: null });
    }

    render() {
        const headers = ["Zpl Name", "Zpl Preview"];
        const colNames = ["zplName", "zplBodyPreview"];

        const tableData = (this.state.tableFilter || []).map((item) => {
            const isLoading = this.state.previewLoadingId === item?._id;

            return {
                ...item,
                zplBodyPreview: (
                    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                        <button
                            className="action-btn"
                            style={{
                                backgroundColor: "#0069D9",
                                border: "none",
                                borderRadius: "10px",
                                minWidth: 120,
                            }}
                            onClick={() => this.openPreviewModal(item)}
                            disabled={isLoading}
                        >
                            <p className="action-txt">{isLoading ? "Loading..." : "Preview"}</p>
                        </button>
                    </div>
                )
            };
        });

        const modalPreviewSrc = this.state.previewModalId
            ? this.state.previewById?.[this.state.previewModalId]
            : null;

        return (
            <>
            <AlertDialog
                    deleteThis="ZPL"
                    onDeletePress={() => this.deleteHandler(this.state?.deleteModal)}
                    open={this.state.deleteModal ? true : false}
                    handleClose={() => this.setState({ deleteModal: null })}
                />
                <Loader loading={this.state.loading} />
                <div className="dashboard-main">
                    <div className="dashboard-top">
                        <div> <p className="stock-count" style={{ fontSize: '25px', margin: 0 }}>Zpl Report</p>
                            <h1 style={{ color: 'black', fontSize: '15px' }}>{new Date().toLocaleString('hi-IN')} </h1>
                        </div>
                        <button onClick={() => window.location.href = '/addZpl'} className="run-btn"><p className="run-text">Add Zpl</p></button>

                    </div>
                    <div className="dashboard-bottom">
                        <div className="drop-data">
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between", width: "280px" }}>
                                {/* <p className="filter-text">Filters</p> */}
                                <Autocomplete
                                disablePortal
                                id="combo-box-demo"
                                size={'small'}
                                options={this.state.zplFilter?.map((item => item?.zplName.trim())).reduce((noDupArr, entry) => {
                                    if (noDupArr?.includes(entry)) {
                                        return noDupArr;
                                    } else {
                                        return [...noDupArr, entry];
                                    }
                                }, []).filter((item => item !== null && item !== undefined))}
                                onChange={(e, v) => this.setState({ searchVal: v === null ? '' : v })}
                                onInputChange={(e) => {
                                    this.setState({ searchVal: e?.target?.value ? e.target.value : "" });
                                }}
                                sx={{ width: 235 }}
                                renderInput={(params) => <TextField
                                    {...params} label="ZPL Name" />}
                            />
                            </div>


                            <div style={{paddingRight: '15px'}}>
                                <button onClick={() => this.onSearchChange()} className="run-btn"><p className="run-text">Search</p></button>
                            </div>


                        </div>

                        <div style={{ paddingTop: "2%" }}>
                            <PaginatedItemsOffline
                                headers={headers}
                                colNames={colNames}
                                Action
                                itemsPerPage={this.state.itemsPerPage}
                                data={tableData}
                                editHandler={(item) => this.editHandler(item)}
                                deleteHandler={(item) => this.setState({ deleteModal: item._id })}
                                refresh={this.state.refreshKey}
                            />
                        </div>

                    </div>
                </div>
                <Dialog
                    open={this.state.previewModalOpen}
                    onClose={this.closePreviewModal}
                    maxWidth="md"
                    fullWidth
                >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px" }}>
                        <Typography sx={{ fontWeight: 800, color: "#111827" }}>
                            ZPL Preview
                        </Typography>
                        <IconButton onClick={this.closePreviewModal} aria-label="close">
                            <IoClose size={22} />
                        </IconButton>
                    </div>
                    <DialogContent dividers style={{ display: "flex", justifyContent: "center" }}>
                        {modalPreviewSrc ? (
                            <img
                                src={modalPreviewSrc}
                                alt="ZPL Preview"
                                style={{
                                    maxWidth: "70%",
                                    height: "auto",
                                    borderRadius: 8,
                                    background: "#fff",
                                }}
                            />
                        ) : (
                            <Typography sx={{ color: "#6B7280" }}>Loading preview...</Typography>
                        )}
                    </DialogContent>
                </Dialog>
            </>

        )
    }
}
export default withRouter(Zpl)